import { ReportsApi, useAPIAction } from "melco-shared-logic";
import { StatisticsConfig } from "./useStatistics";

export const useDownloadReports = (dataConfig: StatisticsConfig) => {
  return useAPIAction(
    ReportsApi,
    async (api) => {
      const response = await api.reportsDownloadRaw({
        startDate: dataConfig?.startTimestamp ?? undefined,
        endDate: dataConfig?.endTimestamp ?? undefined,
        designList:
          dataConfig?.designsFilter?.map((df) => df?.value).join(",") ??
          undefined,
        groupList:
          dataConfig?.machineGroupsFilter?.map((mgf) => mgf?.value).join(",") ??
          undefined,
        isGrouped: dataConfig?.grouped ?? undefined,
      });
      const { raw } = response;
      const blob = await raw.blob();
      const filename = raw.headers.get("x-filename") ?? undefined;
      let data = {
        blob,
        filename,
      };

      // console.log(y)
      return {
        successMessages: [],
        data,
      };
    },
    { translationPrefix: "global" }
  );
};
